export const modalMessagesStep3 = {
    DATE_CONFIRM_TITLE: 'Confirmar fecha de entrega',
    DATE_CONFIRM_DESCRIPTION: 'Hemos seleccionado la fecha más próxima para ti, si no tienes disponibilidad, puedes elegir otro día',
    DATE_CONFIRM_BUTTON_CANCEL: 'Elegir otra fecha',
    DATE_CONFIRM_BUTTON_OK: 'Confirmar',

    SIGNATURE_ERROR_TITLE: 'Lo sentimos, en este momento no podemos realizar la firma de tu solicitud a través del sitio web.',
    SIGNATURE_ERROR_DESCRIPTION: 'Llama al Contact Center al 6000 638 6380 o al +56 2 2661 2700 dónde uno de nuestros ejecutivos te ayudará a contratar el producto o servicio que necesitas.',
    SIGNATURE_ERROR_BUTTON_OK: 'Entendido'
};
